interface UploadArrowIconProps {
  fillColor?: string;
}

/** Small tray-with-arrow icon used on upload affordances. */
export const UploadArrowIcon = (props: UploadArrowIconProps) => {
  const color = props.fillColor ?? "#2563eb";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  );
};
